"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransactionBlockExplorerLinkForNetwork = exports.getAccountBlockExplorerLinkForNetwork = void 0;
const __1 = require("..");
exports.getAccountBlockExplorerLinkForNetwork = async (network, address) => {
    const urls = {
        [__1.NetworkType.MAINNET]: 'https://tezblock.io/account/',
        [__1.NetworkType.CARTHAGENET]: 'https://carthagenet.tezblock.io/account/',
        [__1.NetworkType.CUSTOM]: 'https://carthagenet.tezblock.io/account/'
    };
    const url = urls[network ? network.type : __1.NetworkType.MAINNET];
    return `${url}${address}`;
};
exports.getTransactionBlockExplorerLinkForNetwork = async (network, transactionHash) => {
    const urls = {
        [__1.NetworkType.MAINNET]: 'https://tezblock.io/transaction/',
        [__1.NetworkType.CARTHAGENET]: 'https://carthagenet.tezblock.io/transaction/',
        [__1.NetworkType.CUSTOM]: 'https://carthagenet.tezblock.io/transaction/'
    };
    const url = urls[network ? network.type : __1.NetworkType.MAINNET];
    return `${url}${transactionHash}`;
};
//# sourceMappingURL=block-explorer.js.map